// /frontend/src/pages/dashboard/post/facebook/FacebookOptionsDrawer.js  (v2.0 – modernized UI)
// All logic identical to v1.
import React, { useState } from 'react';
import { validateMedia }      from '../../../../utils/mediaValidator.js';
import { validateMediaByUrl } from '../../../../utils/validateMediaByUrl.js';

const FORMATS = [
  { key: 'feed',  label: 'Feed Post', icon: 'fas fa-newspaper' },
  { key: 'story', label: 'Story',     icon: 'fas fa-circle-notch' },
  { key: 'reel',  label: 'Reel',      icon: 'fas fa-film' },
];

const VIDEO_EXT = ['.mp4', '.mov', '.avi', '.m4v', '.wmv'];

export default function FacebookOptionsDrawer ({ facebookAccounts, updateAccountOption, files = [] }) {
  const [open, setOpen] = useState(true);
  if (!facebookAccounts.length) return null;

  const first        = files[0];
  const isSingle     = files.length === 1;
  const isVideo      = first ? VIDEO_EXT.some(ext => first.url?.toLowerCase().endsWith(ext)) : false;
  const isSingleVideo = isSingle && isVideo;

  const disabledMap = {
    feed : false,
    story: !isSingle,
    reel : !isSingleVideo,
  };

  const tryChangeFormat = async (acc, newFmt) => {
    let result = { ok: true };
    if (first) {
      if (first.file) result = await validateMedia(first.file, { format: newFmt });
      else            result = await validateMediaByUrl(first.url, { format: newFmt });
    }
    if (!result.ok) { alert(`❌ ${result.error}`); return; }
    updateAccountOption(acc.id, acc.platform, { format: newFmt, _auto: false });
  };

  return (
    <div style={{ background:'#ffffff', border:'1px solid #e5e7eb', borderRadius:12, marginBottom:12, overflow:'hidden', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' }}>
      {/* Header */}
      <button
        type='button'
        onClick={() => setOpen(o => !o)}
        style={{ width:'100%', display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', background:'transparent', border:'none', cursor:'pointer' }}
      >
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:'#eff6ff', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
            <i className='fab fa-facebook-f' style={{ fontSize:12, color:'#1877F2' }} />
          </div>
          <span style={{ fontSize:13, fontWeight:700, color:'#111827' }}>Facebook Options</span>
        </div>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} style={{ fontSize:11, color:'#9ca3af' }} />
      </button>

      {/* Body */}
      {open && (
        <div style={{ padding:'4px 16px 16px', borderTop:'1px solid #f3f4f6' }}>
          {facebookAccounts.map(acc => (
            <div key={acc.id} style={{ marginTop:12 }}>
              {facebookAccounts.length > 1 && (
                <div style={{ fontSize:12, fontWeight:600, color:'#6b7280', marginBottom:8 }}>{acc.displayName}</div>
              )}
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {FORMATS.map(fmt => {
                  const disabled  = disabledMap[fmt.key];
                  const isChecked = acc.options?.format === fmt.key;
                  return (
                    <button
                      key={fmt.key}
                      type='button'
                      disabled={disabled}
                      onClick={() => !disabled && tryChangeFormat(acc, fmt.key)}
                      style={{
                        display    : 'flex',
                        alignItems : 'center',
                        gap        : 6,
                        padding    : '6px 12px',
                        borderRadius: 8,
                        border     : `1.5px solid ${isChecked ? '#1877F2' : '#e5e7eb'}`,
                        background : isChecked ? '#eff6ff' : disabled ? '#fafafa' : '#ffffff',
                        color      : isChecked ? '#1877F2' : disabled ? '#d1d5db' : '#374151',
                        fontSize   : 12,
                        fontWeight : isChecked ? 700 : 500,
                        cursor     : disabled ? 'not-allowed' : 'pointer',
                        transition : 'all 0.15s',
                      }}
                    >
                      <i className={fmt.icon} style={{ fontSize:11 }} />
                      {fmt.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}